<template>
	<div>
		<van-popup v-model="modal_model" :style="{ height: '50%' ,width:'90%'}" :lazy-render="true" get-container="body"
			:safe-area-inset-bottom="true" @open="modal_onshow">
			<div class="full flex" style="flex-direction: column;align-items: center;justify-content: center;">
				<div class="full"
					style="position: relative;flex: 1;box-sizing: border-box;padding: 10px;overflow: auto;">
					<van-tabs v-model="activeName">
						<van-tab title="主流程" name="main">
							<van-steps direction="vertical" :active="flowprogressContentMain.length-1">
								<van-step v-for="(item,index) in flowprogressContentMain" :key="index">
									<p>{{item.title}}</p>
									<p>{{item.time}}</p>
								</van-step>
							</van-steps>
						</van-tab>
						<van-tab v-for="(item,index) in flowprogressContentSon" :title="item.flowname"
							:name="item.flowname" :key="index">
							<van-steps direction="vertical" :active="item.content.length-1">
								<van-step v-for="(item,index) in item.content" :key="index">
									<p>{{item.title}}</p>
									<p>{{item.time}}</p>
								</van-step>
							</van-steps>
						</van-tab>

					</van-tabs>
				</div>
				<div style="width: 100%;">
					<van-button type="warning" @click="retrieve" style="width: 50%;">取回</van-button>
					<van-button type="default" @click="modal_cancel" style="width: 50%;">返回</van-button>
				</div>
			</div>
		</van-popup>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			isflow: {
				default: () => {
					return false
				}
			},
			dataid: {
				default: () => {
					return null
				}
			},
			moduleName: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_title: '流程详情',
				modal_width: 600,
				modal_height: 600,
				activeName: 'main',
				flowprogressContentMain: [],
				flowprogressContentSon: [],
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			handleClick() {

			},
			modal_init() {
				this.activeName = 'main'
				this.flowprogressContentMain = []
				this.flowprogressContentSon = []
				this.dataflow()
			},
			dataflow() {
				// console.log(this.row.id, this.moduleName)
				this.$api.flowprogress.list({
					dataid: this.dataid,
					formname: this.moduleName
				}).then((res) => {
					if (res.length == 0) {
						this.$message.error('暂无流程信息')
					} else {
						let flowprogressgroup = this.$Lodash.groupBy(res, 'flowtemplatetype')
						if (flowprogressgroup.son) {
							flowprogressgroup.son = this.$Lodash.groupBy(flowprogressgroup.son, 'flowtemplateid')
						}
						console.log(flowprogressgroup)
						this.flowprogressContentMain = this.createflowdetail(flowprogressgroup.main)
						for (let i in flowprogressgroup.son) {
							this.flowprogressContentSon.push({
								flowname: flowprogressgroup.son[i][0]['flowname'] + '【' + i + '】',
								content: this.createflowdetail(flowprogressgroup.son[i])
							})
						}

					}
				})

			},
			createflowdetail(flowprogress) {
				let flowprogressContent = []
				flowprogress.forEach((item, index) => {
					if (item.currentnodetype != 3) {
						let time = window.systemMethods.timestampToDate(item.update_time * 1000)
						let currentstaff = window.systemMethods.getstaff(item.currentstaffid)
						let nextstaffid = item.nextstaffid ? item.nextstaffid.toString().split(
								',') :
							null
						let nextstaff = []
						if (nextstaffid) {
							nextstaffid.forEach((item) => {
								nextstaff.push(window.systemMethods.getstaff(item))
							})
						}
						nextstaff = nextstaff.join('，')
						let current = {
							time: time,
							currentstaff: currentstaff,
							tag: item.tag ? item.tag : '',
							submit: item.submit ? item.submit : ''
						}
						let currenttitle = ''
						currenttitle += current.currentstaff
						if (current.tag) {
							currenttitle += '【' + current.tag + '】'
						}
						if (current.submit) {
							currenttitle += '（' + current.submit + '）'
						}
						current.title = currenttitle
						let next = null
						flowprogressContent.push(current)
						if (index == flowprogress.length - 1) {
							if (item.isend != 1) {
								next = {
									time: null,
									currentstaff: nextstaff,
									tag: '待执行',
									submit: ''
								}
							} else {
								next = {
									time: null,
									currentstaff: '',
									tag: '结束',
									submit: ''
								}
							}
						}
						if (next) {
							let nexttitle = ''
							nexttitle += next.currentstaff
							if (next.tag) {
								nexttitle += '【' + next.tag + '】'
							}
							if (next.submit) {
								nexttitle += '（' + next.submit + '）'
							}
							next.title = nexttitle
							flowprogressContent.push(next)
						}

					}
				})
				return flowprogressContent
			},
			retrieve() {
				this.$emit('retrieve')
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>